import React from "react";
import Routes from "./routes";
import { SnackbarProvider } from "notistack";
import { ThemeProvider } from "@mui/material/styles";
import { StyledEngineProvider } from "@mui/material";

import { createTheme } from "@mui/material/styles";
import { ConfirmDialogProvider } from "./components/DialogConfirm";
import { PromptDialogProvider } from "./components/PromptDialog";

const theme = createTheme({
  palette: {
    primary: { main: "#253257" },
    secondary: { main: "#F2C26A" },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          boxShadow: "none",
        },
      },
    },
  },
});

const App = () => (
  <div className="App">
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <SnackbarProvider maxSnack={3}>
          <ConfirmDialogProvider>
            <PromptDialogProvider>
              <Routes />
            </PromptDialogProvider>
          </ConfirmDialogProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  </div>
);

export default App;
